import { motion } from "framer-motion";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents, {
  BackButton,
} from "../../../../components/primaryComponents";
import { useParams } from "react-router-dom";
import styles from "./MarketDetails.module.scss";
import appsData from "../../../../localdata/marketApps";
import Error404 from "../../../ErrorPages/Error404";
import {
  Connected,
  ConnectStoreIcon,
  GuardIcon,
  HelpIcon,
  PaperNotesIcon,
  SecurityIcon,
} from "../../../../assets/svgIcons";

import { useSelector } from "react-redux";
import DOMPurify from "dompurify";

const MarketDetails = () => {
  const { id } = useParams();
  const app = appsData.find((app) => app?.id === id);

  const { has_chowdeck_connection, has_squareup_connection } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const { businessDetails } = useSelector(
    (state) => state.profileDetailsReducer,
  );

  if (!app) return <Error404 />;

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | App Market Details"
      description="View app Market Details"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0 }}
          className={globalStyles.pagePaddings}
        >
          <div>
            <BackButton />
          </div>

          <div className="d-flex flex-wrap justify-content-between">
            <div className={`${styles.marketDetails__card}`}>
              <div className={styles.marketDetails__header}>
                <div className="d-flex" style={{ gap: "3px" }}>
                  {app?.id === "vfd" ||
                  app?.id === "chowdeck" ||
                  app?.id === "squareup" ? (
                    app.imageSrc
                  ) : app.id === "paystackPOS" ? (
                    app.imageSrc
                  ) : (
                    <img
                      src={app.imageSrc}
                      alt={app.altText}
                      width={100}
                      height={100}
                      className="rounded mr-2"
                    />
                  )}
                  <div
                    className="mt-3"
                    //style={{ flexDirection: "column", gap: "5px" }}
                  >
                    <h5>{app?.appName}</h5>
                    <span className="comingSoon--app mb-2">
                      FREE TO USE
                    </span>{" "}
                    <br />
                    {(has_chowdeck_connection && app?.appName === "Chowdeck") ||
                    (has_squareup_connection && app?.appName === "Squareup") ||
                    app?.isConnected ||
                    (app?.isPaymentIntegration &&
                      businessDetails?.integrated_payment_providers?.includes(
                        app?.key,
                      )) ? (
                      <span
                        className={`d-flex align-items-center ${globalStyles.statusBlock} success--rounded py-2`}
                        style={{ width: "auto", maxWidth: "fit-content" }}
                      >
                        <Connected className="mr-1" /> Connected
                      </span>
                    ) : (
                      <span
                        className={`${globalStyles.statusBlock} purple white--text py-2`}
                        style={{ width: "auto", maxWidth: "fit-content" }}
                      >
                        Connect
                      </span>
                    )}
                  </div>
                </div>
                {/* {app.status === "Connect" ? ( */}
                <div>
                  <primaryComponents.Button
                    classNames="btn btn--primary"
                    isDisabled={!app?.route}
                    onClick={() => {
                      window.open(app.route, "_blank", "noopener,noreferrer");
                    }}
                  >
                    {/* <AppDisconnectionIcon />{" "} */}
                    <ConnectStoreIcon className="mr-1" color="white" />
                    Manage connection
                  </primaryComponents.Button>
                </div>
                {/* ) : ( */}
                {/* <div>
                    {chowdeckMarketplace &&
                    chowdeckMarketplace?.active &&
                    has_chowdeck_connection &&
                    app.id === "chowdeck" ? (
                      <primaryComponents.Button
                        classNames="btn btn--primary"
                        onClick={() => {
                          window.open(
                            `${pathConstants.APPS_CHOWDECK_CONNECTIONS}`,
                            "_blank",
                            "noopener,noreferrer",
                          );
                        }}
                      >
                        <span className="small-text-size p-2">
                          View connections
                        </span>
                      </primaryComponents.Button>
                    ) : (
                      <primaryComponents.Button
                        classNames="btn btn--success"
                        onClick={() => {
                          window.open(
                            app.id === "chowdeck"
                              ? pathConstants.APPS_CHOWDECK_CONNECTIONS
                              : app.route,
                            "_blank",
                            "noopener,noreferrer",
                          );
                        }}
                        isDisabled={app.id !== "chowdeck"}
                      >
                        <AppConnectionIcon />{" "}
                        <span className="small-text-size p-2">Connect</span>
                      </primaryComponents.Button>
                    )}
                  </div>
                )} */}
              </div>
              <p className="small-text-size p-2">{app?.full_description}</p>
              <hr />
              {app?.videoUrl !== "" ? (
                <div
                  style={{
                    height: "400px",
                    overflow: "hidden",
                    width: "90%",
                    marginBottom: "30px",
                  }}
                >
                  <iframe
                    width="100%"
                    height="100%"
                    loading="lazy"
                    src={`https://www.youtube.com/embed/${app?.videoUrl}`}
                    title="title"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullScreen
                    style={{ borderRadius: "12px", overflow: "hidden" }}
                  ></iframe>
                </div>
              ) : null}
              {Array.isArray(app?.instruction) &&
                app.instruction.some(
                  (item) => item?.step || item?.description,
                ) && (
                  <>
                    <h5 className="default-text-size">Instructions</h5>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      {app.instruction.map(
                        (item, index) =>
                          (item?.step || item?.description) && (
                            <li key={index} className="small-text-size mt-2">
                              {item?.step && <strong>{item.step}</strong>}{" "}
                              {item?.description && (
                                <span>{item.description}</span>
                              )}
                            </li>
                          ),
                      )}
                    </ul>
                  </>
                )}

              <h5 className="default-text-size">Key Features</h5>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                {app?.key_features?.map((item, index) => (
                  <li key={index} className="small-text-size mt-2">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item),
                      }}
                    />
                  </li>
                ))}
              </ul>
              <h5 className="default-text-size">Getting Started</h5>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                {app?.getting_started?.map((item, index) => (
                  <li key={index} className="small-text-size mt-2">
                    {item?.step}{" "}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item?.description),
                      }}
                    />
                  </li>
                ))}
              </ul>

              {app?.what_happens_at_checkout ? (
                <>
                  <h5 className="default-text-size">
                    What Happens at Checkout
                  </h5>
                  <p className="small-text-size dark--text mb-0">
                    {app?.what_happens_at_checkout?.description}
                  </p>

                  <div>
                    <h6 className="mt-3">
                      {app?.what_happens_at_checkout?.subHeader}
                    </h6>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      {app?.what_happens_at_checkout?.contents?.map(
                        (copyText, index) => (
                          <li key={index} className="small-text-size mt-2">
                            <span>{copyText}</span>
                          </li>
                        ),
                      )}
                    </ul>
                  </div>
                </>
              ) : null}

              {app?.why_use_the_integration ? (
                <>
                  <h5 className="default-text-size">
                    Why Use This Integration
                  </h5>

                  <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                    {app?.why_use_the_integration?.map((copyText, index) => (
                      <li key={index} className="small-text-size mt-2">
                        <span>{copyText}</span>
                      </li>
                    ))}
                  </ul>
                </>
              ) : null}
            </div>
            <div className={styles.marketDetails__sideCard}>
              <div>
                <h6 className="default-text-size">App Information</h6>
                <p className="small-text-size">
                  <strong className="dark--text">Developer:</strong>{" "}
                  <span className="smallest-text-size ml-1">
                    {" "}
                    {app?.app_information?.developer}
                  </span>
                </p>
                <p className="small-text-size">
                  <strong className="dark--text">Category:</strong>{" "}
                  <span className="smallest-text-size ml-2">
                    {app?.app_information?.category}
                  </span>
                </p>
              </div>
              <div>
                <h6 className="default-text-size">Pricing Information</h6>
                <p className="smallest-text-size">
                  {app?.app_information?.pricing_information}
                </p>
              </div>
              <div>
                <h6 className="default-text-size">Support</h6>
                <div className="d-flex text-center p-1">
                  <GuardIcon />
                  <a className="smallest-text-size ml-2" href={app?.url}>
                    {app?.support?.user_guide}
                  </a>
                </div>
                <div className="d-flex text-center p-1">
                  <HelpIcon />
                  <a
                    className="smallest-text-size ml-2"
                    href={app?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {app?.support?.email}
                  </a>
                </div>
              </div>
              <div>
                <h6 className="default-text-size">Legal</h6>
                <div className="d-flex text-center p-1">
                  <PaperNotesIcon />
                  <a
                    className="smallest-text-size ml-2"
                    href={app?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {app?.legal?.terms_of_service}
                  </a>
                </div>
                <div className="d-flex text-center p-1">
                  <SecurityIcon />
                  <a
                    className="smallest-text-size ml-2"
                    href={app?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {app?.legal?.privacy_policy}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default MarketDetails;
